import request from '@/utils/request'

// 提交留言信息
export function fetchAddMessage(data) {
    return request({
    url: '/website-service/api/web/submitInfo',
    method: 'post',
    data
  },true) 
}
//照片墙
export function fetchPhotoWall(data) {
  return request({
    url: '/website-service/api/web/photoWall',
    method: 'get',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/index.js